export enum DATA_QA {
  ROOT = 'call-center-select',
}
